<template lang="pug">
    fragment
        // Arrow
        td
            v-icon.icon(:class="{'expanded' : expanded}") keyboard_backspace

        // Business Name
        td {{ item.fullName }}
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';

    export default {
        components: {
            ButtonComponent: ButtonIcon
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        }
    };
</script>
